import {Injectable, signal} from "@angular/core";
import {ClientProperties} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";
import {SimSystemExtendedService} from "./sim-service-system.service";
import {NotificationService} from "src/app/common/services/notification.service";
import {toObservable} from "@angular/core/rxjs-interop";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {SimInjectableDataService} from "./sim-injectable-data.service";

@Injectable({
	providedIn: "root",
})
export class SimDeviceMappingService {
	T = Translations;

	private static _clientProperties = signal<ClientProperties>({} as ClientProperties);
	public static clientProperties = SimDeviceMappingService._clientProperties.asReadonly();
	public static onClientPropertiesChanged: Observable<void>;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _simNotificationService: NotificationService,
		private translate: TranslateService,
		_injectableDataService: SimInjectableDataService,
	) {
		if (!SimDeviceMappingService.onClientPropertiesChanged) {
			SimDeviceMappingService.onClientPropertiesChanged = toObservable(SimDeviceMappingService._clientProperties).pipe(
				map((_) => {}),
			);
		}

		_injectableDataService.networkInterfacesChanged.subscribe(async () => {
			await this.reloadClientProperties();
		});
	}

	public reloadClientProperties() {
		return new Promise<boolean>((resolve) => {
			this._simSystemService
				.getClientProperties()
				.then((data) => {
					if (data) {
						SimDeviceMappingService._clientProperties.set(data);
						resolve(true);
					} else {
						this._simNotificationService.notifyError(
							this.translate.instant(this.T.SESSION_DASHBOARD_COULD_NOT_GET_CLIENT_PROPERTIES),
						);
						resolve(false);
					}
				})
				.catch((response) => {
					// TODO: this is a critical error - no settings means software will have undefined behaviour
					console.error(`Device Mappings/Properties could not be loaded!`);

					SimDeviceMappingService._clientProperties.set({} as ClientProperties);

					resolve(false);
				});
		});
	}
}
